var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4910_5760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.001 17.991V11.391C18.001 8.15099 17.308 5.69099 13.525 5.69099C12.8155 5.66176 12.1114 5.82681 11.4888 6.16834C10.8662 6.50987 10.3487 7.01491 9.992 7.62899H9.95V5.98199H6.375V17.982H10.116V12.042C10.116 10.464 10.407 8.96799 12.361 8.96799C14.315 8.96799 14.301 10.768 14.301 12.153V17.996L18.001 17.991Z",
    fill: "#1077B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.304688 5.98199H4.03169V17.982H0.304688V5.98199Z",
    fill: "#1077B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1759 5.74485e-06C1.74739 -0.000980724 1.32821 0.125096 0.971347 0.362299C0.614483 0.599502 0.335954 0.937182 0.170969 1.33265C0.00598344 1.72812 -0.0380506 2.16363 0.0444323 2.58412C0.126915 3.00462 0.332211 3.39122 0.634371 3.69505C0.936531 3.99889 1.32199 4.20632 1.74202 4.29113C2.16205 4.37594 2.59779 4.33432 2.99417 4.17153C3.39055 4.00873 3.72977 3.73208 3.96894 3.37653C4.20811 3.02098 4.33651 2.60251 4.3379 2.17401V2.14601C4.33393 1.5753 4.10437 1.02934 3.69932 0.627283C3.29427 0.225227 2.74661 -0.000272102 2.1759 5.74485e-06Z",
    fill: "#1077B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4910_5760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.a56a75419cec482d4df3cb90903adc5a.svg";
export { ForwardRef as ReactComponent };